module.exports = __webpack_public_path__ + "static/media/Download-Googleplay.7a7bb9cd.svg";